import { afterNextRender, Component, forwardRef, HostBinding, input, linkedSignal, output, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractControl } from '../abstract-control/abstract-control';
import { CSSValuePipe } from '@pipes/css-value-pipe';

@Component({
  selector: 'app-text-area',
  standalone: true,
  imports: [MatTooltipModule, CSSValuePipe],
  templateUrl: './text-area.html',
  styleUrl: './text-area.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextArea),
      multi: true,
    },
  ],
})
export class TextArea extends AbstractControl<string | undefined, string> {
  // Inputs
  override $value = input<string | undefined>(undefined, { alias: 'value' });
  $_value = linkedSignal(this.$value);
  $inputWidth = input<string>('100%', { alias: 'inputWidth' });
  $hostWidth = input<string>('auto', { alias: 'hostWidth' });
  $placeholder = input<string>('', { alias: 'placeholder' });
  $rows = input<number>(4, { alias: 'rows' });
  $cols = input<number | undefined>(undefined, { alias: 'cols' });
  $resize = input<'none' | 'both' | 'horizontal' | 'vertical'>('vertical', { alias: 'resize' });
  override $controlPosition = input<'default' | 'opposite' | 'top' | 'bottom'>('bottom', { alias: 'controlPosition' });

  // Outputs
  override valueChange = output<string>();

  // Signals / atributos
  override $controlValue = signal<string>('');

  // Bindings
  @HostBinding('style.width')
  get hostWidth(): string { return this.$hostWidth(); }

  // Verificar si se emitirá el valor al iniciar
  constructor() {
    super();
    afterNextRender(() => {
      if (this.$emitAtStart()) {
        const value = (this.$value() !== undefined ? this.$value() : this.$controlValue()) as string;
        this.valueChange.emit(value);
      }
    });
  }

  // Maneja el evento de entrada de texto
  override onValueChange(event: Event) {
    const newValue = (event.target as HTMLTextAreaElement).value;
    if (this.$value() !== undefined)
      this.$_value.set(newValue);
    this.updateValue(newValue);
    this.valueChange.emit(newValue);
  }
}
